import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  IconButton,
  Typography,
  CircularProgress
} from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import Mute from "@material-ui/icons/VolumeMute";
import Unmute from "@material-ui/icons/VolumeUp";
import Fullscreen from "@material-ui/icons/Fullscreen";
import Mic from "@material-ui/icons/Mic";

const useStyles = makeStyles(theme => ({
  root: {
    //width: 'inherit'
    position: "relative",
    height: "100%",
    width: "100%",
    backgroundColor: "black"
  },
  name: {
    position: "absolute",
    left: 3,
    zIndex: theme.zIndex.drawer + 1
  },
  controlsLeft: {
    position: "absolute",
    //left: 5,
    bottom: 10,
    zIndex: theme.zIndex.drawer + 1
  },

  controlsRight: {
    position: "absolute",
    right: 0,
    bottom: 5,
    zIndex: theme.zIndex.drawer + 1
  },

  button: {
    marginLeft: theme.spacing(0.5)
  },

  icon: {
    marginRight: theme.spacing(0.5)
  },

  progress: {
    position: "absolute",
    margin: "auto",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },

  video: {
    height: "100%",
    width: "100%"
  },
  audio: {
    height: "100%",
    width: "100%"
  },
  mic: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    margin: "auto"
  }
}));

export default function Media({ element }) {
  const classes = useStyles();

  const [showControls, setShowControls] = useState(false);
  const [muted, setMuted] = useState(false);
  const [videoReady, setVideoReady] = useState(false);

  const showControl = () => {
    setShowControls(true);
  };

  const hideControls = () => {
    setShowControls(false);
  };

  function showFullscreen() {
    element.mediaRef.current.webkitRequestFullScreen();
  }

  function toggleVolume() {
    if (muted) {
      element.mediaRef.current.volume = 1;
    } else {
      element.mediaRef.current.volume = 0;
    }
    setMuted(!muted);
  }

  useEffect(() => {
    element.mediaRef.current.oncanplay = function() {
      setVideoReady(true);
    };

    //start loading circle and set up event to stop loading circle when video loads
  }, []);

  //console.log("rendering video: ", element);

  return (
    <div
      className={classes.root}
      onMouseOver={showControl}
      onMouseLeave={hideControls}
    >
      {videoReady && (
        <>
          <div className={classes.name}>
            <Typography variant="subtitle2">
              {(element.identity.name && element.identity.name) || "Me"}
            </Typography>
          </div>
          <Fade in={showControls}>
            <div onMouseOver={showControl} onMouseLeave={hideControls}>
              <div className={classes.controlsLeft}>
                <Button
                  variant="outlined"
                  className={classes.button}
                  onClick={toggleVolume}
                >
                  {" "}
                  {muted && (
                    <>
                      <Mute className={classes.icon} />
                      {"Unmute"}
                    </>
                  )}{" "}
                  {!muted && (
                    <>
                      <Unmute className={classes.icon} />
                      {"Mute"}
                    </>
                  )}
                </Button>
                {false && (
                  <Button variant="outlined" className={classes.button}>
                    Hide
                  </Button>
                )}
              </div>

              {element.options.video && (
                <div className={classes.controlsRight}>
                  <IconButton onClick={showFullscreen}>
                    <Fullscreen />
                  </IconButton>
                </div>
              )}
            </div>
          </Fade>
          {element.options.audio && !element.options.video && (
            <Mic fontSize="large" className={classes.mic} />
          )}
        </>
      )}
      {!videoReady && <CircularProgress className={classes.progress} />}

      {element.options.audio && element.options.video && (
        <video autoPlay ref={element.mediaRef} className={classes.video} />
      )}
      {element.options.audio && !element.options.video && (
        <audio autoPlay ref={element.mediaRef} className={classes.audio} />
      )}
    </div>
  );
}
